/* @flow */
import React from 'react';
import { SliderRoot, SlideImg, LastImageCoverText } from './styles';
import { getCroppedImage } from '../../utils/links';
import brokenImageThumb from '../../../public/images/errors/broken-image-480.png';

type TProps = {
	link: string,
	idx: number,
	handleChange?: () => {},
	withMoreImg?: boolean,
	countText?: number,
	withHover?: boolean,
	isSmallText?: boolean,
	withPlusText?: boolean,
	isLayout?: boolean,
};

const SliderImage = ({
	link,
	idx,
	handleChange,
	withMoreImg,
	countText,
	withHover,
	isSmallText,
	withPlusText,
	isLayout,
}: TProps) => (
	<SliderRoot
		key={idx.toString()}
		onClick={handleChange}
		id={`smallSliderImg_${idx.toString()}`}
		index={idx}
		$withHover={withHover}
	>
		<SlideImg $isLayout={isLayout}>
			<img
				src={getCroppedImage(link, '160x160')}
				alt=""
				onError={(e) => {
					e.target.onerror = null;
					e.target.src = brokenImageThumb;
				}}
			/>
			{withMoreImg && (
				<LastImageCoverText className="imgCoverText" $isSmallText={isSmallText}>
					{countText}
					{withPlusText && '+'}
				</LastImageCoverText>
			)}
		</SlideImg>
	</SliderRoot>
);

SliderImage.defaultProps = {
	handleChange: () => {},
	withMoreImg: false,
	countText: null,
	withHover: true,
	isSmallText: false,
	withPlusText: true,
	isLayout: false,
};

export default SliderImage;
